import React, { Component, Fragment } from "react";
import "react-toastify/dist/ReactToastify.css";
import { getAllTransactionRedux } from "../../../actions";
import { connect } from "react-redux";

const STATUS_COLORS = {
  Processing: "#1B75D0",
  Confirmed: "orange",
  Packing: "darkorange",
  Delivered: "green",
  Reduced: "#6c757d",
  Cancelled: "#dc3545",
};

const Badge = ({ label, color }) => (
  <span
    style={{
      display: "inline-block",
      backgroundColor: color || "#6c757d",
      borderRadius: 6,
      color: "white",
      fontSize: 11,
      fontWeight: 600,
      padding: "2px 8px",
      letterSpacing: 0.3,
      whiteSpace: "nowrap",
    }}
  >
    {label}
  </span>
);

export class MonthlyExpense extends Component {
  render() {
    const { sortedTransfers, product, productImage, month, monthsArray } =
      this.props;

    return (
      <div className="col-sm-12">
        <div className="card" style={{ borderRadius: 10, overflow: "hidden" }}>
          {/* Header row: month label + month selector */}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "12px 16px",
              borderBottom: "1px solid #f0f0f0",
            }}
          >
            <div style={{ fontWeight: 700, fontSize: 15, color: "#333" }}>
              {month}
            </div>
            <select
              title="Filter by month"
              name="selectedMonth"
              className="custom-select"
              style={{ maxWidth: 200 }}
              onChange={(e) => this.props.setSelectedMonth(e.target.value)}
              value={this.props.isAllTime ? "all" : ""}
            >
              <option value="">Select a Month</option>
              <option value="all">— All Time —</option>
              {monthsArray.map((m) => (
                <option key={m} value={m}>
                  {m}
                </option>
              ))}
            </select>
          </div>

          {/* Product / variation selector */}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: 10,
              padding: "12px 16px",
              overflowX: "auto",
              borderBottom: "1px solid #f0f0f0",
            }}
          >
            {product &&
            product.displayedVariations &&
            product.displayedVariations.length > 0 ? (
              product.displayedVariations.map((variation) => (
                <div
                  key={variation.id}
                  onClick={() => this.props.setVariationId(variation.id)}
                  style={{
                    padding: 10,
                    border:
                      this.props.variationId === variation.id
                        ? "2px solid darkorange"
                        : "1px solid #e0e0e0",
                    borderRadius: 10,
                    width: 100,
                    minWidth: 100,
                    cursor: "pointer",
                    textAlign: "center",
                    background:
                      this.props.variationId === variation.id
                        ? "#fff8f0"
                        : "#fff",
                  }}
                >
                  <img
                    src={variation.pictures[0] || productImage}
                    style={{
                      height: 60,
                      width: 60,
                      borderRadius: 5,
                      objectFit: "cover",
                      border: "1px solid #e0e0e0",
                    }}
                    alt=""
                  />
                  <div style={{ fontSize: 11, marginTop: 4, color: "#555" }}>
                    {variation.combination.map((c) => c.name).join(", ")}
                  </div>
                </div>
              ))
            ) : (
              <img
                src={productImage}
                style={{
                  height: 90,
                  width: 90,
                  borderRadius: 8,
                  objectFit: "cover",
                  border: "1px solid #e0e0e0",
                }}
                alt="product"
              />
            )}
          </div>

          {/* Table */}
          <div className="card-body" style={{ padding: 0 }}>
            <div style={{ overflowX: "auto" }}>
              <table
                className="table table-bordered table-hover"
                style={{ marginBottom: 0, minWidth: 700 }}
              >
                <thead>
                  <tr>
                    {[
                      "Date",
                      ...(this.props.isAllTime ? ["Month"] : []),
                      "Type",
                      "Note / Order ID",
                      "Status",
                      "Amount",
                      "Qty",
                      "Remaining Stock",
                      "Entry By",
                    ].map((h) => (
                      <th
                        key={h}
                        style={{
                          background: "linear-gradient(135deg, #4F46E5, #7C3AED)",
                          color: "white",
                          fontWeight: 600,
                          fontSize: 12,
                          padding: "12px 14px",
                          whiteSpace: "nowrap",
                          border: "none",
                        }}
                      >
                        {h}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {sortedTransfers.length === 0 ? (
                    <tr>
                      <td
                        colSpan={this.props.isAllTime ? 9 : 8}
                        style={{
                          textAlign: "center",
                          color: "#aaa",
                          padding: 32,
                          fontSize: 14,
                        }}
                      >
                        {this.props.isAllTime
                          ? "No transactions found for this product."
                          : "No transactions for this period."}
                      </td>
                    </tr>
                  ) : (
                    sortedTransfers.map((t, i) => {
                      const isBuying = t.fundType === "Buying";
                      const isSelling = t.fundType === "Selling";
                      const rowBg = isBuying
                        ? "#f6fff6"
                        : isSelling
                        ? "#f0f6ff"
                        : "#fff";

                      const amount = isBuying
                        ? t.totalCost != null
                          ? `${t.totalCost} Tk`
                          : "—"
                        : t.totalBill != null
                        ? `${t.totalBill} Tk`
                        : "—";

                      const qty = isBuying
                        ? t.productStock != null
                          ? `${t.productStock} pc`
                          : "—"
                        : t.sellStock != null
                        ? `${t.sellStock} pc`
                        : "—";

                      // purchasePrice is a price for real purchases but a
                      // label ("Cancelled by admin", "Partial delivered") for
                      // order restocks — only a price gets "Tk", and a restock
                      // also shows which order it came from.
                      const priceIsNumber =
                        t.purchasePrice != null &&
                        t.purchasePrice !== "" &&
                        !isNaN(Number(t.purchasePrice));
                      const noteText = isBuying
                        ? priceIsNumber
                          ? `${t.purchasePrice} Tk`
                          : t.purchasePrice || t.subCategory || "—"
                        : t.subCategory || "—";
                      const extraStyle = { color: "#888", fontSize: 11, marginTop: 2 };
                      const orderRef =
                        isBuying &&
                        !priceIsNumber &&
                        (t.subCategory || "").startsWith("Order Id:") &&
                        noteText !== t.subCategory
                          ? t.subCategory
                          : null;

                      const noteExtra =
                        isSelling && t.note ? (
                          <div style={extraStyle}>{t.note}</div>
                        ) : isBuying && (orderRef || t.cancelNote) ? (
                          <>
                            {orderRef && (
                              <div style={{ ...extraStyle, color: "#555" }}>{orderRef}</div>
                            )}
                            {t.cancelNote && <div style={extraStyle}>{t.cancelNote}</div>}
                          </>
                        ) : null;

                      return (
                        <tr key={t.id || i} style={{ background: rowBg }}>
                          {/* Date */}
                          <td
                            style={{
                              fontSize: 12,
                              color: "#555",
                              whiteSpace: "nowrap",
                              padding: "10px 14px",
                            }}
                          >
                            {t.date || "—"}
                          </td>

                          {/* Month (All Time mode only) */}
                          {this.props.isAllTime && (
                            <td
                              style={{
                                fontSize: 11,
                                color: "#6b7280",
                                whiteSpace: "nowrap",
                                padding: "10px 14px",
                                fontWeight: 500,
                              }}
                            >
                              {t.month || "—"}
                            </td>
                          )}

                          {/* Type badge */}
                          <td style={{ padding: "10px 14px", whiteSpace: "nowrap" }}>
                            {isBuying ? (
                              <Badge label="Stock In" color="#27ae60" />
                            ) : isSelling ? (
                              <Badge label="Sell Out" color="#2980b9" />
                            ) : (
                              <Badge label={t.fundType || "—"} color="#888" />
                            )}
                          </td>

                          {/* Note / Order ID */}
                          <td style={{ fontSize: 13, padding: "10px 14px" }}>
                            {noteText}
                            {noteExtra}
                          </td>

                          {/* Status */}
                          <td style={{ padding: "10px 14px", whiteSpace: "nowrap" }}>
                            {t.orderStatus ? (
                              <Badge
                                label={t.orderStatus}
                                color={STATUS_COLORS[t.orderStatus] || "#888"}
                              />
                            ) : (
                              <span style={{ color: "#ccc" }}>—</span>
                            )}
                          </td>

                          {/* Amount */}
                          <td
                            style={{
                              fontWeight: 600,
                              fontSize: 13,
                              color: isBuying ? "#27ae60" : "#2980b9",
                              padding: "10px 14px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {amount}
                          </td>

                          {/* Qty */}
                          <td
                            style={{
                              fontSize: 13,
                              padding: "10px 14px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {qty}
                          </td>

                          {/* Remaining Stock */}
                          <td
                            style={{
                              fontWeight: 700,
                              fontSize: 13,
                              color: "#333",
                              padding: "10px 14px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {t.remainingStock != null && !isNaN(t.remainingStock)
                              ? `${parseInt(t.remainingStock)} pc`
                              : "—"}
                          </td>

                          {/* Entry By */}
                          <td
                            style={{
                              fontSize: 12,
                              color: "#666",
                              padding: "10px 14px",
                            }}
                          >
                            {t.expenseBy || "—"}
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  transactions: state.products.transactions,
});

export default connect(mapStateToProps, { getAllTransactionRedux })(
  MonthlyExpense
);
